import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(function({ className, ...props }) {
  return <Tooltip {...props} classes={{ popper: className }} />;
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#323232',
    boxShadow: '0 0 20px #63758b59',
    fontSize: 12,
    fontWeight: 400
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    '&::before': {
      backgroundColor: theme.palette.common.white,
      boxShadow: '0 0 20px #63758b59'
    }
  }
}));

export default LightTooltip;
